<div class="dropdown" dropdown>
  <a *ngIf="!iconName" dropdownToggle class="nav-link dropdown-toggle" [routerLink]="" queryParamsHandling="merge">
    <span class="navbar-brand text-uppercase wrapp-text">{{selected?.name}}</span><span class="caret"></span>
    <span class="navbar-brand extra" *ngIf="extraInfo">{{extraInfo}}</span>
    <span class="caret"></span>
  </a>

  <span *ngIf="!!iconName">
    <i dropdownToggle [class]="'icon ' + iconName" aria-hidden="true"></i>
  </span>

  <ul *dropdownMenu class="dropdown-menu bg-dark text-light" role="menu">
    <li role="menuitem" *ngFor="let item of options" ><a class="dropdown-item text-secondary text-uppercase" [href]="" (click)="onSelectOption(item)" >{{item?.name}}</a></li>
  </ul>
</div>
